module.exports = __webpack_public_path__ + "static/empire-of-the-summer-moon-e63251130a07c03f04acc5537d4cd672.jpg";